var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PenEventName } from "../common/enums";
import { NEO_SMARTPEN_TYPE } from "../common/neopen/INeoSmartpen";
import PenComm, { deviceSelectDlg } from "./pencomm/pencomm";
import SmartPenBase from "./SmartPenBase";
// const NUM_HOVER_POINTERS = 6;
export default class NeoSmartpen extends SmartPenBase {
    /**
     *
     * @param customStorage
     */
    constructor(customStorage = null) {
        super(customStorage, undefined, undefined);
        /**
         * npm install -D @types/web-bluetooth
         *
         * @return {*}  {BluetoothDevice}
         * @memberof NeoSmartpen
         */
        this.getBtDevice = () => {
            return this.protocolHandler.getBtDevice();
        };
        this.getMac = () => {
            // return this.getBtDevice().id;
            return this.protocolHandler.getMac();
        };
        /**
         * @param requestOnlineDataOnConencted Eanble online data transfer on connection
         *
         * @return {*}  {Promise<boolean>}
         * @memberof NeoSmartpen
         */
        this.connect = (requestOnlineDataOnConencted = true) => __awaiter(this, void 0, void 0, function* () {
            let device = null;
            try {
                device = yield deviceSelectDlg();
                this.webBluetoothId = device.id;
            }
            catch (e) {
                console.log(e);
                return false;
            }
            if (this.manager.isBtPenAlreadyConnected(device)) {
                console.error(`bluetooth device(id:${device.id}) already connectged or connecting process is being processed`);
                return false;
            }
            if (device) {
                const ret = yield this.protocolHandler.connect(device, requestOnlineDataOnConencted);
                return ret;
                // this.manager.add(this, device);
            }
            else {
                console.error("Device NULL");
                return false;
            }
            return true;
        });
        /**
         *
         *
         * @param {BluetoothDevice} device
         * @return {*}
         * @memberof NeoSmartpen
         */
        this.connectByWebBtDevice = (device, requestOnlineDataOnConencted = true) => __awaiter(this, void 0, void 0, function* () {
            return this.protocolHandler.connect(device, requestOnlineDataOnConencted);
        });
        /**
         *
         *
         * @memberof NeoSmartpen
         */
        this.disconnect = () => {
            this.protocolHandler.disconnect();
        };
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof NeoSmartpen
         */
        // onPenDown(event: IPenCommEvent) {
        //   super.onPenDown(event);
        // }
        /**
         * 펜의 움직임
         *    1) down/up이 있는 경우: DOWN -> INFO -> MOVE -> MOVE -> ... -> UP -> INFO와 같이 나옴
         *    2) hove의 경우: (페이지가 바뀌면) INFO -> HOVER_MOVE -> HOVER_MOVE...
         *
         * pen down 된 후의 page info, 실질적으로 pen_down과 같음
         *
         * @param {IPenCommEvent} event
         * @param {boolean} hover
         * @memberof NeoSmartpen
         */
        // onPageInfo(event: IPenCommEvent, hover: boolean) {
        //   super.onPageInfo(event, hover);
        // }
        /**
         * pen down 상태에서 움직임
         *
         * @param {IPenCommEvent} event
         * @memberof NeoSmartpen
         */
        // onPenMove(event: IPenCommEvent) {
        //   super.onPenMove(event);
        // }
        /**
         * hover 상태에서 움직임
         *
         * @param {IPenCommEvent} event
         * @memberof NeoSmartpen
         */
        // onHoverMove(event: IPenCommEvent) {
        //   super.onHoverMove(event);
        // }
        /**
         * hover 상태에서 페이지 바뀜
         *
         * @param {IPenCommEvent} event
         * @memberof NeoSmartpen
         */
        // onHoverPageInfo(event: IPenCommEvent) {
        //   super.onHoverPageInfo(event);
        // }
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof NeoSmartpen
         */
        // onPenUp(event: IPenCommEvent) {
        //   super.onPenUp(event);
        // }
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof NeoSmartpen
         */
        // onNcodeError(event: IPenCommEvent) {
        //   super.onNcodeError(event);
        // }
        /**
         * 2021/08/18
         * @param event
         * @returns
         */
        // onPasscodeRequired(event: IPenCommEvent) {
        //   super.onPasscodeRequired(event);
        // }
        /**
         * 2021/08/18
         * @param passcode
         */
        // sendPasscode(passcode: string) {
        //   super.sendPasscode(passcode);
        // }
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof NeoSmartpen
         */
        this.onConnected = (event) => {
            console.log("CONNECTED");
            const webBluetoothId = this.getBtDevice().id;
            if (this.webBluetoothId !== webBluetoothId) {
                // 이런 경우가 생기면 안되는 데 말이지
                console.error(`BT dialog BTID(${this.webBluetoothId}is not equal to BtDevideID(${webBluetoothId})`);
                this.webBluetoothId = webBluetoothId;
            }
            const mac = this.protocolHandler.getMac();
            this.mac = mac;
            this.connected = true;
            console.log(`Connected: ${mac}`);
            this.manager.add(this);
            // this.manager.onConnected({ pen: this, event });
            this.dispatcher.dispatch(PenEventName.ON_CONNECTED, {
                inputType: this.inputType,
                pen: this, mac, event: event
            });
        };
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof NeoSmartpen
         */
        // onFirmwareUpgradeNeeded(event: IPenCommEvent) {
        //   super.onFirmwareUpgradeNeeded(event);
        // }
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof NeoSmartpen
         */
        // onDisconnected(event: IPenCommEvent) {
        //   super.onDisconnected(event);
        // }
        /**
         * 2021/08/09
         * Pen의 호버 모드를 ON/OFF
         * @param on
         */
        this.setHoverMode = (on) => {
            this.protocolHandler.setHoverMode(on ? 1 : 0);
        };
        /**
       * 2021/08/18
       * @param event
       */
        this.onPenStatusResponse = (event) => {
            this.maxPenPressureValue = event.status.maxPressureValue;
            const mac = event.mac;
            this.dispatcher.dispatch(PenEventName.ON_PEN_STATUS_RESPONSE, {
                inputType: this.inputType,
                pen: this, mac, event: event
            });
        };
        /**
         * 2022/05/18
         */
        this.onFinishedOfflineDownload = (event) => {
            var _a;
            console.log(`onFinishedOfflineDownload, numStrokes:${(_a = event.offlineData.strokes) === null || _a === void 0 ? void 0 : _a.length}`);
            this.offlineDataProgressReportCb = null;
            // console.log(event, event.offlineData.strokes);
        };
        this.onStartOfflineDownload = (event) => {
            console.log(`onStartOfflineDownload`);
            // console.log(event);
        };
        this.onOfflineDataDelivered = (event) => {
            if (this.offlineDataProgressReportCb) {
                const { totalStrokeCount, receivedStrokeCount, strokes } = event.offlineData;
                this.offlineDataProgressReportCb({
                    pen: this,
                    numTotal: totalStrokeCount,
                    numCompleted: receivedStrokeCount,
                    strokes
                });
            }
            // console.log(`onOfflineDataDelivered, received stroke at this turn ${event.offlineData?.strokes?.length}`);
            // console.log(event);
        };
        this.onOfflineDataListDelivered = (event) => {
            console.log(`onOfflineDataListDelivered, offline strokes: ${event.offlineDataList.length}`);
            // console.log(event);
            // data list 에서 데이터를 받자.
            // const list = event.offlineDataList;
            // if (list?.length) {
            //   const item = list[0];
            //   const { Section: s, Owner: o, Note: b, Pages: pgs } = item;
            //   this.protocolHandler.reqOfflineData(s, o, b, pgs)
            // }
            // NU_TO_PU = 25/168;
            // 1 NU = 8 * 7 /600 inch => 600/(8x7) DPI, ncode coordinate (stroke)
            // 1 PU = 1/72 inch => 72 DPI, nrpoj coordinate
        };
        this.onPasswordChanged = (event) => {
            console.log(`onPasswordChanged`);
            // console.log(event);
        };
        this.requestOfflineDataList = (section = undefined, owner = undefined, book = undefined) => __awaiter(this, void 0, void 0, function* () {
            const ret = yield this.protocolHandler.reqOfflineDataList();
            return ret;
        });
        this.offlineDataProgressReportCb = null;
        this.totalOfflineStrokes = 0;
        this.ddownloadedStrokes = 0;
        this.reqOfflineData = (s, o, b, pgs = null, deleteOnFinished = true, progressReportCb = null) => __awaiter(this, void 0, void 0, function* () {
            this.offlineDataProgressReportCb = progressReportCb;
            this.totalOfflineStrokes = 0;
            this.ddownloadedStrokes = 0;
            return this.protocolHandler.reqOfflineData(s, o, b, pgs, deleteOnFinished);
        });
        this.inputType = NEO_SMARTPEN_TYPE.REAL_PEN;
        this.connected = false;
        this.protocolHandler = new PenComm(this);
    }
}
//# sourceMappingURL=NeoSmartpen.js.map